import React from 'react';
import {FeaturesList, Grid2Columns, Item, SectionHeader} from '../utils/Styled';
import {Trans, useI18next} from 'gatsby-plugin-react-i18next';
import {MenuItemIcon} from '../utils/MenuItemIcon';
import {InternalPageLink} from 'components/links/Pages';

import {AnchorLink} from 'components/AnchorLink';
import SoonIndicator from '../utils/SoonIndicator';
import {MenuLink, Props} from '../utils/types';
import {paymentMethods, ecommercePlatforms} from '../constants/integrations';

export const Integrations: React.FC<Props> = ({itemClick}) => {
  const {language} = useI18next();
  const renderItem = (item: MenuLink) => (
    <Item key={item.slug}>
      <MenuItemIcon name={item.icon} />
      {item.slug ? (
        <>
          <InternalPageLink slug={item.slug} activeClassName="active" onClick={itemClick}>
            {item.title}
          </InternalPageLink>
          {item.soon && <SoonIndicator>{item.soon}</SoonIndicator>}
        </>
      ) : item.to ? (
        <AnchorLink href={item.toByLanguage?.[language] || item.to} target="_blank">
          {item.title}
        </AnchorLink>
      ) : (
        <>
          {item.title}
          {item.soon && <SoonIndicator>{item.soon}</SoonIndicator>}
        </>
      )}
    </Item>
  );

  return (
    <Grid2Columns columnWidth="220px">
      <div>
        <SectionHeader marginTop="0">
          <Trans>Payment methods</Trans>
        </SectionHeader>
        <FeaturesList>{paymentMethods.map(renderItem)}</FeaturesList>
      </div>
      <div>
        <SectionHeader marginTop="0">
          <Trans>E-commerce platforms</Trans>
        </SectionHeader>
        <FeaturesList>{ecommercePlatforms.map(renderItem)}</FeaturesList>
      </div>
    </Grid2Columns>
  );
};
